import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=194a8ac3&scoped=true&"
import script from "./Portal.vue?vue&type=script&lang=js&"
export * from "./Portal.vue?vue&type=script&lang=js&"
import style0 from "./Portal.vue?vue&type=style&index=0&id=194a8ac3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a8ac3",
  null
  
)

export default component.exports